export const CheckedIcon = ({
  className,
  inheritColor = false,
}: {
  className?: string;
  inheritColor?: boolean;
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill={inheritColor ? "currentColor" : "var(--swapper-text-color)"}
      className={className || ""}
    >
      <path d="M10.4444 16.6667L18.2778 8.83333L16.7222 7.27778L10.4444 13.5556L7.27778 10.3889L5.72222 11.9444L10.4444 16.6667ZM4.22222 22C3.61111 22 3.08796 21.7824 2.65278 21.3472C2.21759 20.912 2 20.3889 2 19.7778V4.22222C2 3.61111 2.21759 3.08796 2.65278 2.65278C3.08796 2.21759 3.61111 2 4.22222 2H19.7778C20.3889 2 20.912 2.21759 21.3472 2.65278C21.7824 3.08796 22 3.61111 22 4.22222V19.7778C22 20.3889 21.7824 20.912 21.3472 21.3472C20.912 21.7824 20.3889 22 19.7778 22H4.22222ZM4.22222 19.7778H19.7778V4.22222H4.22222V19.7778Z" />
    </svg>
  );
};
